/* eslint-disable no-unused-vars */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Field } from 'redux-form';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import TertiaryButton from '../../../lib/ui/buttons/TertiaryButton';
import Checkbox from '../../../lib/ui/form_elements/Checkbox';
import DatePicker from '../../../lib/ui/form_elements/DatePicker';
import SitecorecontextFactory from '../../../lib/SitecoreContextFactory';
import { colors } from '../../../theme/style-helpers';
import {
  LeftSideBarBodyContainer, TitlesContainer, Title, SubTitle, DatesContainer,
} from './css';
import {
  CategoryContainer, CategoryTitle, BoxContainer, BoxInfo,
} from '../css';
import { ErrorMessage } from '../../ReactComponent/RenderField/css';
import Reset from '../../../assets/icons/Reset.svg';
import { Locales } from '../../../utils/enums';

const BOX_CONTAINER_MAX_WIDTH = '347px';
const BOX_CONTAINER_MAX_HEIGHT = '226px';

export const ApplyFiltersBody = ({ filters, data }) => {
  registerLocale('fr', fr);
  setDefaultLocale(SitecorecontextFactory.context.language === Locales.English ? 'en' : 'fr');

  const [showBoxError, setShowBoxError] = useState(false);

  const accountNumbersValidation = (accountNumbers) => (value) => {
    if (value && value.length > 20) {
      setShowBoxError(true);
    } else {
      setShowBoxError(false);
    }
  };

  const ValidateAccount = useMemo(() => accountNumbersValidation(data.accountNumbers), [data]);

  return (
    <LeftSideBarBodyContainer>
      <TitlesContainer>
        <Title>{t('ApplyFilters')}</Title>
        <SubTitle>{t('ApplyFiltersSubTitle')}</SubTitle>
      </TitlesContainer>

      <CategoryContainer>
        <CategoryTitle>{t('ServiceLevel')}</CategoryTitle>
        <BoxContainer
          bgColor={colors.LIGHT_GREY}
          maxWidth={BOX_CONTAINER_MAX_WIDTH}
          maxHeight={BOX_CONTAINER_MAX_HEIGHT}
        >
          <BoxInfo>
            <Field
              name={filters.serviceLevels.name}
              component={Checkbox}
              options={filters.serviceLevels.options}
              multiple
            />
          </BoxInfo>
        </BoxContainer>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>{t('CreatedOn')}</CategoryTitle>
        <DatesContainer>
          <Field
            type="date"
            name={filters.fromDate.name}
            component={DatePicker}
            label={t('From')}
          />
          <Field
            type="date"
            name={filters.toDate.name}
            component={DatePicker}
            label={t('To')}
          />
        </DatesContainer>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>{t('BillingAccount')}</CategoryTitle>
        <BoxContainer
          bgColor={colors.LIGHT_GREY}
          maxWidth={BOX_CONTAINER_MAX_WIDTH}
          maxHeight={BOX_CONTAINER_MAX_HEIGHT}
        >
          <BoxInfo>
            <Field
              name={filters.accountNumbers.name}
              component={Checkbox}
              options={filters.accountNumbers.options}
              multiple
              validate={[ValidateAccount]}
            />
          </BoxInfo>
        </BoxContainer>
        {showBoxError && (
        <ErrorMessage>{t('FilterBillingAccountLimit')}</ErrorMessage>
        )}
      </CategoryContainer>
    </LeftSideBarBodyContainer>
  );
};

export const ApplyFiltersFooter = ({ clearFilters, applyFilters, disabled }) => (
  <>
    <TertiaryButton
      label={t('ClearFilters')}
      onClick={clearFilters}
      showArrow={false}
      iconSrc={Reset}
      isIconLeftPosition
    />
    <PrimaryButton
      label={t('ApplySelection')}
      onClick={applyFilters}
      disabled={disabled}
    />
  </>
);

ApplyFiltersBody.propTypes = {
  filters: PropTypes.object,
  data: PropTypes.object,
};

ApplyFiltersFooter.propTypes = {
  clearFilters: PropTypes.func,
  applyFilters: PropTypes.func,
  disabled: PropTypes.bool,
};
